var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import services from '../../services';
var UsersSharedAppsService = services.UsersSharedAppsService;
export var loadUsersSharedApps = function (appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var usersSharedApps, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'LOAD_USERS_SHARED_APPS_REQUEST' });
                return [4 /*yield*/, UsersSharedAppsService.fetchUsersSharedApps(appId)];
            case 1:
                usersSharedApps = (_a.sent()).objects;
                dispatch({
                    type: 'LOAD_USERS_SHARED_APPS_SUCCESS',
                    usersSharedApps: usersSharedApps,
                });
                return [3 /*break*/, 3];
            case 2:
                err_1 = _a.sent();
                dispatch({
                    type: 'LOAD_USERS_SHARED_APPS_FAILURE',
                    err: err_1,
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var deleteUsersSharedApp = function (appId, senderAppId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'DELETE_USERS_SHARED_APP_REQUEST' });
                    return [4 /*yield*/, UsersSharedAppsService.deleteUsersSharedApp(appId, senderAppId)];
                case 1:
                    _a.sent();
                    dispatch({
                        type: 'DELETE_USERS_SHARED_APP_SUCCESS',
                        senderAppId: senderAppId,
                    });
                    return [2 /*return*/, true];
                case 2:
                    error_1 = _a.sent();
                    dispatch({
                        type: 'DELETE_USERS_SHARED_APP_FAILURE',
                        error: error_1,
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, false];
            }
        });
    }); };
};
export var createUsersSharedApp = function (appId, usersSharedAppId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'CREATE_USERS_SHARED_APP_REQUEST' });
                    return [4 /*yield*/, UsersSharedAppsService.createUsersSharedApp(appId, usersSharedAppId)];
                case 1:
                    _a.sent();
                    dispatch({
                        type: 'CREATE_USERS_SHARED_APP_SUCCESS',
                        usersSharedAppId: usersSharedAppId,
                    });
                    return [2 /*return*/, true];
                case 2:
                    error_2 = _a.sent();
                    dispatch({
                        type: 'CREATE_USERS_SHARED_APP_FAILURE',
                        error: error_2,
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, false];
            }
        });
    }); };
};
export var loadUsersSharedByApps = function (appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var usersSharedByApps, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'LOAD_USERS_SHARED_BY_APPS_REQUEST' });
                    return [4 /*yield*/, UsersSharedAppsService.getUsersSharedByApps(appId)];
                case 1:
                    usersSharedByApps = (_a.sent()).objects;
                    dispatch({
                        type: 'LOAD_USERS_SHARED_BY_APPS_SUCCESS',
                        usersSharedByApps: usersSharedByApps,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    dispatch({
                        type: 'LOAD_USERS_SHARED_BY_APPS_FAILURE',
                        err: err_2,
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
